import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=73436780&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73436780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73436780')) {
      api.createRecord('73436780', component.options)
    } else {
      api.reload('73436780', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=73436780&scoped=true", function () {
      api.rerender('73436780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/footer.vue"
export default component.exports